<template>
  <div data-message-holder></div>
  <section class="[ px-5 !pt-0 !pb-0 max-w-7xl mx-auto w-full h-full ]">
    <router-view />
  </section>
</template>

<script setup lang="ts">
definePage({
  meta: {
    icon: "hierarchy-square",
    title: "QA",
    scope: "QAConfig.Read",
  },
  redirect: "/rules/rulesets",
});
</script>
